"use client";

import { c as _c } from "react/compiler-runtime";
import { IconExclamationTriangle } from "central-icons/IconExclamationTriangle";
import { EmptyState } from "@/components/common/empty-state";
import { SectionContainer } from "@/components/common/section-container";
import { Button } from "@/components/ui/button";
interface ErrorBoundaryFallbackProps {
  reset: () => void;
}
export function ErrorBoundaryFallback(t0) {
  const $ = _c(5);
  const {
    reset
  } = t0;
  let t1;
  if ($[0] !== reset) {
    t1 = <Button className="w-full" onClick={reset} variant="secondary">Try again</Button>;
    $[0] = reset;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconExclamationTriangle mode="raw" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <SectionContainer className="min-h-[calc(100dvh-var(--nav-height))]"><EmptyState actions={t1} className="mb-16" description="An unexpected error occurred. Please try again." icon={t2} title="Something went wrong" /></SectionContainer>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}